import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { routes } from "./constant";
import SpinnerContextProvider, {
  LoadingSpinnerContext,
} from "./components/SpinnerContext";
import { lazy, Suspense } from "react";
import { LoadingSpinner } from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppIcon from "./components/WhatsAppIcon";
import { Toaster } from "react-hot-toast";
import CallUsButton from "./components/CallUsButton";
const WebDevelopment = lazy(() =>
  import("./pages/landingPages/WebDevelopment")
);
const AppDevelopment = lazy(() =>
  import("./pages/landingPages/AppDevelopment")
);
const AIDevelopment = lazy(() => import("./pages/landingPages/AIDevelopment"));
const ChatbotDevelopment = lazy(() =>
  import("./pages/landingPages/ChatbotDevelopment")
);
const ThankYou = lazy(() => import("./pages/ThankYou"));

AOS.init({
  once: true,
  duration: 1000,
  easing: "ease-in-out-quart",
  throttleDelay: 200,
});

function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <SpinnerContextProvider>
        <Router>
          <LoadingSpinnerContext />
          <div className="fixed right-6 bottom-6 z-50 flex flex-col gap-5">
            <WhatsAppIcon />
            <CallUsButton />
          </div>
          <ScrollToTop />
          <Toaster
            position="top-bottom"
            toastOptions={{
              style: {
                background: "#010C2A",
                color: "#ffffff",
              },
            }}
          />
          <Routes>
            {/* Website pages */}
            {routes.map((route) => (
              <Route path={route.path} element={route.element} />
            ))}

            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/thank-you" element={<ThankYou />} />

            {/* Landing pages */}
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/app-development" element={<AppDevelopment />} />
            <Route path="/ai-development" element={<AIDevelopment />} />
            <Route
              path="/chatbot-development"
              element={<ChatbotDevelopment />}
            />
          </Routes>
        </Router>
      </SpinnerContextProvider>
    </Suspense>
  );
}

export default App;
